@if (journey.trip(); as trip) {
  <p class="mb-4 text-base font-semibold">
    {{
      textStore.texts()
        | filterTexts
          : ERelationType.onDemandTripDate
          : EEntityType.onDemandTicketConfiguration
        | language
    }}
    {{ journey.tripDate() | date: 'dd.MM.yyyy' }}
  </p>

  <div class="flex flex-col">
    @for (leg of trip.legs; track $index; let legIndex = $index) {
      <div class="relative flex min-h-30 flex-row gap-4">
        <div class="relative flex w-6 shrink-0 flex-col items-center">
          <div
            class="relative z-10 h-7 w-7 rounded-full border-3"
            [ngStyle]="{
              borderColor: corporateDesign.primaryColor(),
              backgroundColor: corporateDesign.surface1(),
            }"></div>
          <div
            class="absolute top-5 bottom-0"
            [class.w-1]="!isTransferLeg(leg)"
            [class.border-l-2]="isTransferLeg(leg)"
            [class.border-dashed]="isTransferLeg(leg)"
            [ngStyle]="{
              backgroundColor: isTransferLeg(leg)
                ? 'transparent'
                : corporateDesign.primaryColor(),
              borderColor: isTransferLeg(leg)
                ? corporateDesign.primaryBorderColor()
                : 'transparent',
            }"></div>
        </div>
        <div class="relative flex flex-1 flex-col">
          @if (
            journey.isOnDemandLeg(leg.operator.id) &&
            journey.hasDepartureDeviation()
          ) {
            <div class="flex flex-row items-baseline gap-2">
              <span class="text-sm line-through opacity-40">
                {{ formatSimpleTime(leg.origin.time) }}
              </span>
              <span class="text-base font-medium">{{ leg.origin.name }}</span>
            </div>
            <span
              class="text-base font-bold"
              [ngStyle]="{
                color: corporateDesign.isDarkModeActive()
                  ? corporateDesign.corporateDesign().colorAdmixtures
                      .error_red_dark
                  : corporateDesign.corporateDesign().colorAdmixtures.error_red,
              }">
              {{ selectionState.confirmedDeparture() }}
              @if (
                selectionState.departureDeviationMinutes();
                as departureDeviation
              ) {
                <span class="text-sm font-semibold">
                  ({{
                    departureDeviation > 0
                      ? '+' + departureDeviation
                      : departureDeviation
                  }}
                  min)
                </span>
              }
            </span>
          } @else {
            <div class="flex flex-row items-baseline gap-2">
              <span class="text-base font-bold">
                {{ getDisplayDeparture(leg, trip.legs[legIndex - 1]) }}
              </span>
              <span class="text-base font-medium">{{ leg.origin.name }}</span>
            </div>
          }

          @if (isTransferLeg(leg)) {
            <span
              class="absolute left-11 w-fit -translate-y-1/2 text-sm font-medium whitespace-nowrap opacity-60"
              style="top: calc(50% + 0.875rem)">
              {{
                getTransferLabel(
                  leg,
                  trip.legs[legIndex + 1],
                  getTransferDepartureTime(trip.legs[legIndex + 1]),
                  getTransferArrivalTime(trip.legs[legIndex - 1])
                )
              }}
            </span>
          } @else if (journey.isOnDemandLeg(leg.operator.id)) {
            <span
              class="absolute left-11 w-fit -translate-y-1/2 rounded-xl px-3 py-2 text-sm font-semibold whitespace-nowrap"
              style="top: calc(50% + 0.875rem)"
              [ngStyle]="{
                backgroundColor: corporateDesign.primaryColor(),
                color: corporateDesign.corporateDesign().primaryDarkFontColor,
              }">
              {{ getTransportName(leg, journey.operatorName()) }}
            </span>
          } @else {
            <span
              class="absolute left-11 w-fit -translate-y-1/2 rounded-xl border px-3 py-2 text-sm font-semibold whitespace-nowrap"
              style="top: calc(50% + 0.875rem)"
              [ngStyle]="{
                borderColor: corporateDesign.primaryBorderColor(),
              }">
              {{ getTransportName(leg) }}
            </span>
          }
        </div>
      </div>
    }

    <div class="relative flex flex-row items-start gap-4">
      <div class="relative flex w-6 shrink-0 flex-col items-center">
        <div
          class="relative z-10 h-7 w-7 rounded-full border-3"
          [ngStyle]="{
            borderColor: corporateDesign.primaryColor(),
            backgroundColor: corporateDesign.surface1(),
          }"></div>
      </div>
      <div class="flex flex-col gap-1">
        @if (journey.hasArrivalDeviation()) {
          <div class="flex flex-row items-baseline gap-2">
            <span class="text-sm line-through opacity-40">
              {{ formatSimpleTime(trip.destination.time) }}
            </span>
            <span class="text-base font-medium">
              {{ trip.destination.name }}
            </span>
          </div>
          <span
            class="text-base font-bold"
            [ngStyle]="{
              color: corporateDesign.isDarkModeActive()
                ? corporateDesign.corporateDesign().colorAdmixtures
                    .error_red_dark
                : corporateDesign.corporateDesign().colorAdmixtures.error_red,
            }">
            {{ selectionState.confirmedArrival() }}
          </span>
        } @else {
          <div class="flex flex-row items-baseline gap-2">
            <span class="text-base font-bold">
              {{ formatSimpleTime(trip.destination.time) }}
            </span>
            <span class="text-base font-medium">
              {{ trip.destination.name }}
            </span>
          </div>
        }
      </div>
    </div>
  </div>
}
